/*
 * gro-gwp-tick.js: the gift-with-purchase tick box above Add to cart
 * (snippets/gro-gwp-tick.liquid).
 *
 * Flow (Tyrone, 30 Sep): greyed out until the order reaches the threshold, then
 * a live box the shopper ticks themselves.
 *   unlocks   this item takes the order over: a ticked box rides with Add to cart
 *             (assets/product-form.js sends product and gift in one request)
 *   unlocked  the order is already over: ticking adds the gift at once, so nobody
 *             has to buy a second of this product to claim it
 *
 * Keeping it current: the bag changes through Dawn's add and the cart drawer
 * (both publish cart-update), through apps that call the cart endpoints
 * directly, in other tabs, and before back/forward restores. Each of those
 * re-reads the bag from sections/gro-gwp-state.liquid; only Liquid can see which
 * lines count, because that depends on collections.
 */
(function () {
  'use strict';

  var CART_RE = /\/cart\/(add|change|update|clear)/;
  var cartListeners = [];
  var watching = false;

  // One network-level hook for the page: fires after any cart request, whoever made it.
  function watchCartRequests(fn) {
    cartListeners.push(fn);
    if (watching) return;
    watching = true;
    var notify = function () {
      cartListeners.forEach(function (f) {
        f();
      });
    };
    try {
      var origFetch = window.fetch;
      window.fetch = function () {
        var result = origFetch.apply(this, arguments);
        try {
          var a = arguments[0];
          var url = typeof a === 'string' ? a : a instanceof URL ? a.href : (a && a.url) || '';
          if (CART_RE.test(url)) result.then(notify, function () {});
        } catch (e) {}
        return result;
      };
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (CART_RE.test(String(url || ''))) this.addEventListener('loadend', notify);
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };
    } catch (e) {}
  }

  function init(root) {
    if (root.dataset.groGwpReady) return;
    root.dataset.groGwpReady = '1';

    // Quick-add modals reuse the product info markup; the box is product-page only.
    if (root.closest('quick-add-modal')) {
      root.remove();
      return;
    }

    var box = root.querySelector('[data-gro-gwp-box]');
    if (!box) return;
    var note = root.querySelector('[data-gro-gwp-note]');
    var fill = root.querySelector('[data-gro-gwp-fill]');
    var nextBar = root.querySelector('[data-gro-gwp-next]');
    var togo = root.querySelector('[data-gro-gwp-togo]');
    var status = root.querySelector('[data-gro-gwp-status]');
    var S = {};
    try {
      S = JSON.parse(root.querySelector('[data-gro-gwp-strings]').textContent);
    } catch (e) {}

    var threshold = Number(root.dataset.threshold);
    var eligible = Number(root.dataset.eligible);
    var inBag = root.dataset.inbag === '1';
    var price = Number(root.dataset.price);
    var counts = root.dataset.counts === 'true';
    var noteOn = root.dataset.note === 'true';
    var mode = root.dataset.mode;
    var adding = false;
    var info = root.closest('.product__info-container');
    var button = document.getElementById('ProductSubmitButton-' + root.dataset.section);

    function money(cents) {
      return (S.money || 'HK$') + (cents / 100).toLocaleString('en-HK', { maximumFractionDigits: 2 });
    }

    // Globo pre-order runs its own add flow; offering the gift there would promise
    // something that flow won't deliver. The pre-order mirror in main-product.liquid
    // marks the column with .gro-is-preorder.
    function preorder() {
      return !!(info && info.classList.contains('gro-is-preorder'));
    }

    function nextMode() {
      if (preorder()) return 'hidden';
      var over = eligible >= threshold;
      if (inBag) return over ? 'inbag' : 'pending';
      if (over) return 'unlocked';
      if (counts && eligible + price >= threshold) return 'unlocks';
      if (counts) return 'locked';
      return noteOn ? 'excluded' : 'hidden';
    }

    // Only the "this item takes you over" box rides with Add to cart, so only it
    // relabels the button. Dawn resets the label on every size change; this runs
    // after each one. Never touches Sold out or an app's own label.
    function relabel() {
      if (!button) return;
      var label = button.querySelector('span');
      if (!label) return;
      var base = (window.variantStrings && window.variantStrings.addToCart) || '';
      var ours = label.querySelector('.gro-gwp-atc');
      var want = mode === 'unlocks' && box.checked && !box.disabled && !button.disabled;
      if (want && !ours && label.textContent.trim() === base.trim()) {
        label.textContent = '';
        var full = document.createElement('span');
        full.className = 'gro-gwp-atc gro-gwp-atc--full';
        full.textContent = S.atcFull || base;
        var short = document.createElement('span');
        short.className = 'gro-gwp-atc gro-gwp-atc--short';
        short.textContent = S.atcShort || base;
        label.appendChild(full);
        label.appendChild(short);
      } else if (!want && ours) {
        label.textContent = base;
      }
    }

    function render() {
      var next = nextMode();
      var offer = next === 'unlocks' || next === 'unlocked';
      // Every new state starts unticked: the shopper ticks it themselves.
      if (next !== mode || !offer) box.checked = false;
      box.disabled = !offer || adding;
      mode = next;
      root.dataset.mode = next;
      // The bold line never changes ("Gift: …"); the second line does.
      if (note) {
        note.textContent =
          next === 'inbag' ? S.inBag || '' : next === 'pending' ? S.inBagPending || '' : S.freeOver || '';
      }

      // The bar measures the bag's GROCERY items. On "unlocks", this item's share
      // runs on to the end, which is why the box is live.
      var pct = Math.min(100, (eligible / threshold) * 100);
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      if (nextBar) {
        nextBar.style.left = pct.toFixed(1) + '%';
        nextBar.style.width = (next === 'unlocks' ? 100 - pct : 0).toFixed(1) + '%';
      }
      if (togo) {
        var toGo = money(Math.max(0, threshold - eligible));
        togo.textContent =
          next === 'unlocks'
            ? String(S.toGoUnlocks || '').replace('[amount]', toGo)
            : next === 'unlocked'
            ? S.unlocked || ''
            : String(S.toGo || '').replace('[amount]', toGo);
      }
      relabel();
    }

    var busy = false;
    var again = false;
    var timer = null;
    function refresh() {
      if (busy) {
        again = true;
        return;
      }
      busy = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + '?sections=gro-gwp-state', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          var m = String((json && json['gro-gwp-state']) || '').match(/data-gro-gwp-state="(\d+)\|([01])"/);
          if (!m) return;
          eligible = Number(m[1]);
          inBag = m[2] === '1';
          render();
        })
        .catch(function () {})
        .finally(function () {
          busy = false;
          if (again) {
            again = false;
            refresh();
          }
        });
    }
    // Several triggers usually fire for one change; they collapse into one read.
    function soon() {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    }

    // The order is already over: put the gift in the bag now, without opening the
    // drawer. The header count updates from the same request; the drawer re-renders
    // its lines on the cart-update below (assets/cart.js).
    function addGiftNow() {
      adding = true;
      root.setAttribute('aria-busy', 'true');
      render();
      var config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items: [{ id: Number(box.value), quantity: 1 }],
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname,
      });
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res.status) {
            box.checked = false; // e.g. sold out a moment ago; the read below puts the row right
            return;
          }
          inBag = true;
          var bubble = document.getElementById('cart-icon-bubble');
          var html = res.sections && res.sections['cart-icon-bubble'];
          if (bubble && html) {
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (src) bubble.innerHTML = src.innerHTML;
          }
          if (status) status.textContent = S.added || '';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gro-gwp', cartData: res });
          }
        })
        .catch(function () {
          box.checked = false;
        })
        .finally(function () {
          adding = false;
          root.removeAttribute('aria-busy');
          render();
          soon();
        });
    }

    box.addEventListener('change', function () {
      if (mode === 'unlocked' && box.checked) {
        addGiftNow();
        return;
      }
      relabel();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        if (v && typeof v.price === 'number') price = v.price;
        render();
      });
    }
    watchCartRequests(soon);

    // A page restored from the browser's cache, or a bag changed in another tab,
    // carries an old bag: re-read on restore and whenever the tab comes back.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) soon();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') soon();
    });

    if (info) new MutationObserver(render).observe(info, { attributes: true, attributeFilter: ['class'] });

    render();
    // Self-heal on every load, as the free-shipping bar does: pages served from
    // the browser's cache on Back skip pageshow's persisted flag.
    setTimeout(refresh, 400);
  }

  function start() {
    document.querySelectorAll('[data-gro-gwp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
